"use client"
import { Button, ButtonBaseActions, Typography } from "@mui/material"
import { visuallyHidden } from "@mui/utils"
import { CarVideoDto, CarVideoLobbyMetaData } from "api"
import { useIsDesktop } from "common/MediaQueries"
import SingleButtonSelection from "common/bit/SingleButtonSelection"
import FormikForm from "common/bit/form/FormikForm"
import Image from "next/image"
import { useCallback, useEffect, useRef, useState } from "react"
import ButtonBaseBlank from "reusable/ButtonBaseBlank"
import FormSelect from "reusable/formsComp/FormSelect"
import VideoPopUp from "reusable/popups/VideoPopUp"
import styled from "styled-components"
import colors from "theme/colors"
import { StyledCol, StyledDividerH, StyledRow } from "theme/shared"
import InnerPageWrapper from "../../../reusable/wrappers/InnerPageWrapper"
import schemaCarFleet, {
  initialFormStatesCarFleet,
} from "../carFleet/SchemaCarFleet"
import VideoCard from "./VideoCard"

const StyledTabsWrap = styled.div`
  overflow: hidden;
`
const StyledSingleButtonSelection = styled(SingleButtonSelection)`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 34px;
  margin: 40px 0px;
  /* sdfkjhsdfjkdhsf */
  /* hide scrollbar: */
  overflow-x: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  &::-webkit-scrollbar {
    /* WebKit */
    display: none;
  }
  ${(p) => p.theme.breakpoints.up("md")} {
    justify-content: center;
    gap: 74px;
    padding: 5px;
  }
`
const StyledButton = styled.label<{ $activeButton: boolean }>`
  cursor: pointer;
  width: 100%;
  height: 100%;
  :focus {
    outline: none;
  }
  div {
    max-width: 50px;
    /* ssdfdsfsdfsfddsf */
  }
`

const StyledFormSelectWrapper = styled.div`
  width: 320px;
  margin: 0px auto;
`

const StyledButtonText = styled(Typography).attrs({ variant: "caption" })<{
  $activeButton: boolean
}>`
  color: ${(p) =>
    p.$activeButton ? p.theme.colors.black : p.theme.colors.disable};
  font-weight: ${(p) => (p.$activeButton ? "bold" : "normal")};
`
const StyledButtonWrap = styled.div`
  margin: 40px auto 0px;
`
type VideoTutorialPageProps = {
  data: CarVideoLobbyMetaData
}

const ADD_MORE_CARDS = 6

const VideoTutorialPage = ({ data }: VideoTutorialPageProps) => {
  const [next, setNext] = useState(ADD_MORE_CARDS)
  const [selectedVideoUrl, setSelectedVideoUrl] = useState<string | undefined>(
    undefined
  )
  const [selectedVideoPopUp, setSelectedVideoPopUp] = useState(false)
  const [selectedModel, setSelectedModel] = useState<string | undefined>(
    undefined
  )
  const [selectedCategoryId, setSelectedCategoryId] = useState(
    data.categories[0].id
  )
  const isDesktop = useIsDesktop()
  const [videosToShow, setVideosToShow] = useState<CarVideoDto[]>([])
  const [allVideos, setAllVideos] = useState<CarVideoDto[]>([])
  const videoRef = useRef<ButtonBaseActions>(null)

  const modelsList = data.carVideos
    .map((item: CarVideoDto) => item.carName)
    .filter((value, i, array) => array.indexOf(value) === i)
    .sort((a, b) => a.localeCompare(b))

  useEffect(() => {
    if (!selectedModel && modelsList) {
      setSelectedModel(modelsList[0])
    }
  }, [modelsList])

  useEffect(() => {
    // Filter videos by category
    const filteredVideos = data.carVideos
      .filter((item: CarVideoDto) => {
        if (selectedCategoryId === data.categories[0].id) {
          return true
        }
        return item.categoryId === selectedCategoryId
      })
      // Filter videos by car model
      .filter((item: CarVideoDto) => {
        if (selectedModel === null) {
          return true
        }
        return item.carName === selectedModel
      })
    setAllVideos(filteredVideos)
    setVideosToShow(filteredVideos.slice(0, next))
  }, [data.carVideos, data.categories, next, selectedCategoryId, selectedModel])

  const handleMoreClick = useCallback(() => {
    // get the next X videos
    const nextVideos = allVideos.slice(next, next + ADD_MORE_CARDS)
    // update the next index
    setNext((prev) => prev + ADD_MORE_CARDS)
    // update the videos to show
    setVideosToShow([...videosToShow, ...nextVideos])
  }, [allVideos, next, videosToShow])

  useEffect(() => {
    if (videoRef?.current) {
      videoRef.current.focusVisible?.()
    }
  }, [videosToShow])

  return (
    <InnerPageWrapper
      title="המאזדה שלך, נעים להכיר"
      subtitle="המושב שמתכוונן בדיוק בשבילך, מערכות הבטיחות האקטיביות שיגנו עליך ומערך התקשורת החכם - ככל שמכירים אותה יותר, ככה היא מרגשת יותר. כדי להפיק את המקסימום מהמאזדה שלך, הכנו סרטונים שמציגים את כל היכולות והפרטים שכדאי להכיר"
      imgUrl={
        isDesktop
          ? "/img/cover/tutorialvideos.jpg"
          : "/img/cover/tutorialvideosmobile.jpg"
      }
      breadCrumbName="VideoTutorials"
    >
      <FormikForm
        validationSchema={schemaCarFleet}
        initialValues={initialFormStatesCarFleet}
        onSubmit={async () => {}}
        render={() => (
          <StyledFormSelectWrapper>
            <FormSelect
              id="cityAutocomplete"
              name="select"
              color="primary"
              label="בחירת דגם"
              values={modelsList}
              map={(item) => ({ id: item, name: item })}
              onChange={(e) => {
                setSelectedModel(e?.target?.value)
                setNext(ADD_MORE_CARDS)
              }}
              focused
              value={selectedModel}
            />
          </StyledFormSelectWrapper>
        )}
      />
      <Typography sx={visuallyHidden} component="span" id="era-selection">
        סינון סרטונים
      </Typography>
      <StyledTabsWrap>
        <StyledSingleButtonSelection
          id="era-selection"
          items={data.categories.map((item) => ({
            value: item.id,
            name: item.name,
            radioItemMore: {
              checkIcon: item.checkIcon,
              unCheckIcon: item.unCheckIcon,
            },
          }))}
          itemsPerRow={"auto"}
          selectedValue={selectedCategoryId}
          onSelect={(code) => {
            setSelectedCategoryId(Number(code))
            setNext(ADD_MORE_CARDS)
          }}
          customButton={(radioId, isSelected, item) => (
            <StyledButton htmlFor={radioId} $activeButton={isSelected}>
              <StyledCol $gap="4px">
                <Image
                  alt={item.name}
                  src={
                    isSelected
                      ? item?.radioItemMore.checkIcon
                      : item?.radioItemMore.unCheckIcon
                  }
                  width={22}
                  height={22}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    objectFit: "contain",
                  }}
                />
                <StyledButtonText $activeButton={isSelected}>
                  {item.name}
                </StyledButtonText>
                <StyledDividerH
                  $color={isSelected ? colors.black : "transparent"}
                  $width={4}
                  $radius={3}
                />
              </StyledCol>
            </StyledButton>
          )}
        />
      </StyledTabsWrap>
      <StyledRow $gap="40px" $fullWidth $wrap $justify="center">
        {videosToShow?.map((item, index) => (
          <ButtonBaseBlank
            key={`video-${item.id}`}
            onClick={() => {
              setSelectedVideoUrl(item.videoUrl)
              setSelectedVideoPopUp(true)
            }}
            action={index === next - 6 ? videoRef : null}
          >
            <VideoCard data={item} selectedModel={selectedModel} />
          </ButtonBaseBlank>
        ))}
      </StyledRow>
      {next < allVideos?.length && (
        <StyledButtonWrap>
          <Button variant="outlined" onClick={() => handleMoreClick()}>
            עוד סרטונים
          </Button>
        </StyledButtonWrap>
      )}
      <VideoPopUp
        url={selectedVideoUrl ?? ""}
        open={selectedVideoPopUp}
        onClose={() => {
          setSelectedVideoPopUp(false)
          setSelectedVideoUrl(undefined)
        }}
        label="video-lable"
      />
    </InnerPageWrapper>
  )
}

export default VideoTutorialPage
